// Splits "PLAN A" labels so the word "PLAN" can be styled separately from the letter.
export const splitPlanLabel = (label: string) => {
  const trimmed = label.trim()
  const match = trimmed.match(/^(PLAN|Plan)\s+(.+)$/)
  if (!match) return { prefix: null as string | null, suffix: trimmed }
  return { prefix: match[1], suffix: match[2] }
}
